@if (sendOnAtaEnabled) {
  <app-form-group [label]="readonly && declaration.status.sent?.date ? 'Sent on ATA berth' : 'Send on ATA berth'">
    <app-yes-no [(ngModel)]="sendOnAta"
                (ngModelChange)="onToggleSendOnAta()"
                [disabled]="readonly"></app-yes-no>
  </app-form-group>
  @if (!declaration.status.sendOnAta || declaration.status.sent?.date) {
    @if (readonly && declaration.status.sent?.date) {
      <app-form-group label="Date sent">
        <app-date-field [disabled]="true" [dateOnly]="true" [required]="true" (change)="emitChange()"
                        [ngModel]="declaration.status.sent.date"></app-date-field>
      </app-form-group>
    } @else {
      <app-form-group label="Send date">
        <app-date-field [disabled]="readonly" [dateOnly]="true" [required]="true" (change)="emitChange()"
                        [minDate]="minDate" [calendarStartDate]="today"
                        [(ngModel)]="declaration.status.sendDate"></app-date-field>
      </app-form-group>
    }
  }
}
@if (!sendOnAtaEnabled) {
  @if (readonly && declaration.status.sent?.date) {
    <app-form-group label="Date sent">
      <app-date-field [disabled]="true" [dateOnly]="true" [required]="true" (change)="emitChange()"
                      [ngModel]="declaration.status.sent.date"></app-date-field>
    </app-form-group>
  } @else {
    <app-form-group label="Send date">
      <app-date-field [disabled]="readonly" [dateOnly]="true" [required]="true" (change)="emitChange()"
                      [minDate]="minDate" [calendarStartDate]="today"
                      [(ngModel)]="declaration.status.sendDate"></app-date-field>
    </app-form-group>
  }
}
@if (includeSealsEnabled) {
  <app-form-group label="Include seals">
    <app-yes-no [(ngModel)]="includeSeals" (ngModelChange)="emitChange()"></app-yes-no>
  </app-form-group>
}
